import React from 'react'
import { UserCheck } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

export const SelfServices: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Employee Self Services</h1>
        <p className="text-gray-600 dark:text-gray-400 mt-2">Self-service portal for employees</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <UserCheck className="w-5 h-5" />Self Service Portal
          </CardTitle>
          <CardDescription>Employee self-service features and tools</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <UserCheck className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium mb-2">Self Services</h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">Employee portal for requests and information</p>
            <Button variant="outline">Explore Services</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
